import { TextField, TextFieldProps } from '@mui/material';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import get from 'lodash/get';

export type DefaultTextFieldProps = TextFieldProps & {
	name: string;
	rules?: RegisterOptions;
};

export const DefaultTextField = ({ name, rules, helperText, ...rest }: DefaultTextFieldProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const fieldError = get(errors, name);

	const fieldErrorMessage =
		typeof fieldError === 'object' &&
		fieldError !== null &&
		'message' in fieldError &&
		typeof (fieldError as { message?: unknown }).message === 'string'
			? (fieldError as { message: string }).message
			: undefined;

	const resolvedHelperText = fieldErrorMessage ?? helperText;

	return (
		<TextField
			{...register(name, rules)}
			error={Boolean(fieldError)}
			helperText={resolvedHelperText}
			slotProps={{
				formHelperText: { component: 'div' },
			}}
			{...rest}
		/>
	);
};
